import {useEffect, useState} from 'react';

import {useTheme} from '@mui/material';
import googleMapsDesktop from 'presentation/assets/images/googleMapsDesktop.webp';
import googleMapsMobile from 'presentation/assets/images/googleMapsMobile.webp';
import {useMediaQueries} from 'presentation/pages';
import {isMapAvailable} from '../../utils/validateMap';
import {UseAppointmentAddressProps} from './types';

export function useAppointmentAddress({addressForMaps, hideMap}: UseAppointmentAddressProps) {
	const theme = useTheme();
	const {isMobile} = useMediaQueries();
	const [mapAvailable, setMapAvailable] = useState(true);

	const mapsImage = isMobile ? googleMapsMobile : googleMapsDesktop;

	const encodedAddress = encodeURIComponent(addressForMaps);
	const googleMapsApiKey = process.env.GOOGLE_MAPS_EMBED_API_KEY;
	const mapSrc = googleMapsApiKey
		? `https://www.google.com/maps/embed/v1/place?key=${googleMapsApiKey}&q=${encodedAddress}`
		: '';

	const hideMapComponent = !googleMapsApiKey || !mapAvailable || hideMap;

	useEffect(() => {
		if (!googleMapsApiKey) {
			setMapAvailable(false);
			return;
		}

		isMapAvailable(mapSrc).then(setMapAvailable);
	}, [googleMapsApiKey, mapSrc]);

	return {
		hideMapComponent,
		mapsImage,
		theme,
		isMobile,
		mapSrc,
	};
}
